import { render } from "./CommonSettings.vue?vue&type=template&id=3b34340a&scoped=true"
import script from "./CommonSettings.vue?vue&type=script&lang=js"
export * from "./CommonSettings.vue?vue&type=script&lang=js"

import "./CommonSettings.vue?vue&type=style&index=0&id=3b34340a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b34340a"]])

export default __exports__